<template>
  <div class="grid items-start gap-3">
    <div class="grid items-start gap-2 rounded-xl bg-white p-3" :key="loading">
      <div v-if="loading" class="w-full min-h-[500px] pb-5 flex flex-col gap-3">
        <CPreloader
          width="100%"
          height="48px"
          :loading="loading"
          v-for="i in 5"
          :key="i"
        />
      </div>
      <template v-else>
        <div
          v-for="(item, index) in faq"
          :key="index"
          class="group transition-300"
        >
          <div
            class="flex items-center parent-item p-3 py-[10px] gap-2 justify-between border border-transparent cursor-pointer transition-300 rounded-lg hover:border-green"
            :class="[
              selectedItem == item.id && !childSelected
                ? 'bg-green-100 !border-green'
                : '',
            ]"
            @click="tabHandler(item)"
          >
            <h4
              class="text-sm text-dark-100 leading-4 transition-colors font-bold duration-300 group-hover:text-dark"
            >
              {{ item.title }}
            </h4>
            <div
              v-if="item?.children.length"
              class="flex-y-center justify-center transition-300 rotate-[-90deg] icon-chevron-curved text-[#535E69] text-xl flex-shrink-0 w-5 h-5 rounded-lg"
              :class="{ active: selectedItem == item.id }"
            ></div>
          </div>
          <div
            v-for="child in item.children"
            :key="child?.id"
            @click="tabChildHandler(child.id, item.id)"
          >
            <div
              v-if="selectedItem == item.id"
              class="text-dark-100 mt-2 transition-300 py-3 border border-transparent rounded-lg hover:border-green cursor-pointer"
              :class="[
                selectedChildItem == child.id
                  ? 'bg-green-100 !border-green'
                  : '',
              ]"
            >
              <p
                class="!leading-130 text-dark-100 grid gap-3 pl-6 pr-3 text-sm"
                :class="answerClass"
              >
                {{ child?.title }}
              </p>
            </div>
          </div>
        </div>
      </template>
    </div>
  </div>
</template>
<script setup lang="ts">
import { onMounted, ref } from "vue";
import { useRoute, useRouter } from "vue-router";

import CPreloader from "@/components/CPreloader.vue";

interface Props {
  faq: IFaq[];
  questionClass?: string;
  answerClass?: string;
  isDormitory?: boolean;
  loading?: boolean;
}

interface Emits {
  (e: "update:modelValue", value: string | number): void;
  (e: "change", value: string | number): void;
}

interface IFaq {
  id: number;
  title: string;
  children: {
    id: number;
    title: string;
  }[];
}

const props = defineProps<Props>();
const emit = defineEmits<Emits>();

const route = useRoute();
const router = useRouter();

const selectedItem = ref();
const selectedChildItem = ref();
const childSelected = ref(false);

const tabHandler = (item: IFaq) => {
  if (item?.children?.length) {
    emit("change", item?.children?.[0]?.id);
    router.push({
      query: { tab: item.id.toString(), child: item?.children?.[0]?.id },
    });
    childSelected.value = true;
    selectedChildItem.value = item?.children?.[0]?.id;
    selectedItem.value = selectedItem.value === item.id ? 0 : item.id;
  }
};

const tabChildHandler = (id: number | string, parentId: number | string) => {
  emit("change", id);
  router.push({ query: { tab: parentId, child: id.toString() } });
  selectedChildItem.value = id;
  childSelected.value = true;
};

const catchQuery = () => {
  if (route.query?.tab) {
    selectedItem.value = route.query.tab;
  }
  if (route.query?.tab && route.query.child) {
    selectedChildItem.value = route.query.child;
    childSelected.value = true;
  }
  if (!selectedItem.value) {
    childSelected.value = true;
    selectedChildItem.value = props.faq[0]?.children?.[0]?.id;
    selectedItem.value = props.faq[0]?.id;
    router.push({
      query: { tab: props.faq[0]?.id, child: props.faq[0]?.children?.[0]?.id },
    });
  }
};

onMounted(() => {
  if (route.query?.tab && route.query.child) {
    tabChildHandler(+route.query.child, +route.query?.tab);
  }
  catchQuery();
});
</script>

<style scoped lang="postcss">
.icon-chevron-curved {
  position: relative;
  cursor: pointer;
}

.icon-chevron-curved.active {
  @apply rotate-[0deg];
}
</style>
